import { Component } from "@angular/core";

import { StateService } from "../../../@core/utils";

@Component({
    selector: "ngx-theme-settings",
    styleUrls: ["./theme-settings.component.scss"],
    template: ``,
})
export class ThemeSettingsComponent {
    layouts = [];
    sidebars = [];

    constructor(protected stateService: StateService) {
        this.stateService.getLayoutStates().subscribe((layouts: any[]) => (this.layouts = layouts));

        this.stateService.getSidebarStates().subscribe((sidebars: any[]) => (this.sidebars = sidebars));
    }

    layoutSelect(layout: any): boolean {
        this.layouts = this.layouts.map((l: any) => {
            l.selected = false;
            return l;
        });

        layout.selected = true;
        this.stateService.setLayoutState(layout);
        return false;
    }

    sidebarSelect(sidebars: any): boolean {
        this.sidebars = this.sidebars.map((s: any) => {
            s.selected = false;
            return s;
        });

        sidebars.selected = true;
        this.stateService.setSidebarState(sidebars);
        return false;
    }
}
